import React from 'react';

const ImageTest: React.FC = () => {
  const testImages = [
    // Tree images
    '/images/trees/eucalyptus1.jpg.webp',
    '/images/trees/Oak1.jpeg',
    '/images/trees/cypress1',
    '/images/trees/eucalyptus_leaves.jpeg',
    '/images/trees/oak_leaves.jpeg',
    '/images/trees/cypress_leaves',
    // Bird images
    '/images/birds/red-winged black bird.jpeg',
    '/images/birds/mourning dove.jpeg',
    '/images/birds/house finch.jpeg',
    '/images/birds/acorn woodpecker.jpeg',
    '/images/birds/california scrub jay.jpeg',
    '/images/birds/wild turkey.jpeg',
    '/images/birds/monarch butterfly.webp',
    '/images/birds/brown pelican.jpeg',
    '/images/birds/double created cormorant.jpeg',
    // Insect images
    '/images/insects/eucalyptus_longhorned_borer.avif',
    '/images/insects/eucalyptus_weevil.jpeg',
    '/images/insects/oak moth caterpillar.jpeg',
    '/images/insects/gall-wasp.jpeg',
    '/images/insects/cypress-bark-beetle.webp',
    '/images/insects/cypress scale insect.webp'
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h2>Image Loading Test</h2>
      {testImages.map((src, index) => (
        <div key={index} style={{ margin: '10px 0' }}>
          <p>Testing: {src}</p>
          <img 
            src={src} 
            alt={`Test ${index}`}
            style={{ width: '200px', height: '150px', objectFit: 'cover', border: '1px solid #ccc' }}
            onLoad={() => console.log(`✅ Loaded: ${src}`)}
            onError={() => console.log(`❌ Failed: ${src}`)}
          />
        </div>
      ))}
    </div>
  );
};

export default ImageTest;